import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { textFieldProps } from "../shared/constants";
import { useState } from "react";
import { Save } from "@mui/icons-material";
import { getFunctions, httpsCallable } from "firebase/functions";
const functions = getFunctions();

export default function AddEmailToUser({ open, onClose, userId }) {
  const [email, setEmail] = useState("");
  const [userPass, setUserPass] = useState("");
  const [busy, setBusy] = useState(false);

  const handleEmailUpdate = async (e) => {
    e.preventDefault();
    setBusy(true);
    if (userPass.length < 6) {
      window.alert("Please enter a longer password.");
      return;
    }
    const executeFunction = httpsCallable(
      functions,
      "updateUserEmailAndPassword"
    );
    const result = await executeFunction({
      uid: userId,
      email,
      userPass,
    });

    // @ts-ignore
    if (result.error) {
      // @ts-ignore
      window.alert("Error: ", result.message);
      setBusy(false);
    }
    // @ts-ignore
    window.alert("Success!");
    setEmail("");
    setUserPass("");
    setBusy(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update User Email & PW</DialogTitle>
      <form onSubmit={handleEmailUpdate}>
        <DialogContent>
          <Stack>
            <TextField
              {...textFieldProps}
              label={"Email Address"}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              type="email"
              required
            />
            <TextField
              {...textFieldProps}
              label={"Password"}
              onChange={(e) => setUserPass(e.target.value)}
              value={userPass}
              type="password"
              required
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={<Save />}
            color="primary"
            type="submit"
            disabled={busy}
          >
            Update
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
